<div class="flex justify-between px-6 py-5">
    <p class="text-[1.125rem] text-[#0A0A0A] font-bold">Write a testimony</p>
    <img
        src="/assets/images/shared/cross-black-icon.svg"
        alt="Close"
        class="h-6 w-6 cursor-pointer"
        (click)="onCancel()" />
</div>

<form [formGroup]="testimonyForm" (ngSubmit)="submit()">
    <mat-dialog-content class="space-y-5 pb-5 border-t border-[#E2E8F0]">
        <!-- Testimony -->
        <div>
            <textarea
                formControlName="testimony"
                placeholder="#Testimony"
                rows="4"
                class="w-full form-field-container font-normal p-3 focus:outline-none resize-none"></textarea>
            <!-- Error message -->
            @if (testimonyForm.get('testimony')?.invalid && testimonyForm.get('testimony')?.touched) {
                <div class="text-red-500 text-xs mt-1">Please enter a testimony.</div>
            }
        </div>
    </mat-dialog-content>

    <mat-dialog-actions>
        <button
            type="submit"
            class="border-button sm:p-3 p-2 rounded-full flex-shrink-0 mt-3 sm:mt-0"
            [disabled]="testimonyForm.invalid">
            <img src="/assets/images/shared/up-arrow-icon.png" alt="Up" class="h-5 w-auto" />
        </button>
    </mat-dialog-actions>
</form>
